import { Link } from 'react-router-dom';
import { styled } from '@mui/material';

export const sxStyles = {
  cipCodesWrap: {
    overflowY: 'scroll',
    maxHeight: '552px',
  },
  majorsBg: {
    backgroundColor: '#F9F9F9',
  },
  mainSectionWrap: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '2rem',
  },
  mainSectionContent: {
    maxWidth: '952px',
    width: '100%',
  },
  checkBoxLabel: {
    display: 'flex',
    alignItems: 'center',

    '& > div:first-of-type': {
      display: 'flex',
      marginLeft: '0.25rem',
    },
  },
};

export const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,

  '&:hover': {
    cursor: 'default',
  },
}));

export const StyledDesktopFiltersWrap = styled('div')(({ theme }) => ({
  width: 'auto',
  overflow: 'visible',
  visibility: 'visible',
  height: 'auto',

  [theme.breakpoints.down('md')]: {
    width: '1px',
    height: '1px',
    overflow: 'hidden',
    visibility: 'hidden',
  },
}));

export const StyledMainSectionActions = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  marginBottom: '2rem',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    alignItems: 'center',
  },

  [theme.breakpoints.up('sm')]: {
    marginBottom: '1.5rem',
  },
}));

export const StyledMajorCardsWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '2rem',

  [theme.breakpoints.down('md')]: {
    gap: '2rem 3rem',
  },

  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
  },
}));

export const StyledBottomPaginationWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',

  [theme.breakpoints.up('sm')]: {
    justifyContent: 'start',
  },

  [theme.breakpoints.up('sm')]: {
    justifyContent: 'space-between',
  },
}));
